import { conversationTagsConstants } from '@constants/conversation-tags';

const initialState = {
    data: [],
    loaded: false,
};

export function conversationTags(state = initialState, action) {
    switch (action.type) {
        case conversationTagsConstants.CONVERSATION_TAGS_SUCCESS:
            return { ...state, data: action.payload, loaded: true };
        case conversationTagsConstants.CONVERSATION_TAGS_ERROR:
        default:
            return state;
    }
}
